import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Heading, Text } from "../../util/typography";
import { ink, blueberry, blueberryDark } from "../../util/colors";
import ComponentWrapper from '../layout/ComponentWrapper';

const Wrapper = styled.div`
    display: flex;
    padding: 50px 104px;
    justify-content: center;
    align-items: center;
    align-content: center;
    gap: 8px;
    flex-wrap: wrap;
    border-radius: 20px;
    background: linear-gradient(135deg, #F4FCDD 0%, #D6EFEF 100%);
    @media (max-width: 768px) {
        padding: 30px 20px;
        align-items: flex-start;
        // gap: 10px;
        background: radial-gradient(154.66% 132.04% at 0% 13.78%, #F4FCDD 0%, #D6EFEF 100%);
    }
`;
const PatientCardHeading = styled(Heading.H3)`
  color: ${ink};
  text-align: center;
`;

const Message = styled(Text.Body)`
    text-align: center;
    color: ${ink};
    margin: 0;
    .text-nowrap{
    white-space: nowrap;
    }

    a {
        color: ${blueberry};
        font-weight: 500;
        display: inline;
        background-position: left calc(100% - 1px);
        background-repeat: no-repeat;
        background-color: transparent;
        cursor: pointer;
        border-width: medium;
        border-style: none;
        border-color: currentcolor;
        border-image: none;
        padding: 0px;
        margin: 0px;
        text-decoration: none;
        will-change: transform;
        backface-visibility: hidden;
        background-image: linear-gradient(transparent, transparent), linear-gradient(rgb(0, 110, 173), rgb(0, 110, 173));
        background-size: 0% 1.1px, 100% 1.1px;
        transition: color 0.3s ease-in-out;
        cursor: pointer;
        
        
        :hover{            
            color: ${blueberryDark};
            background-size: 100% 1.1px, 100% 1.1px;
            background-image: linear-gradient(rgb(0, 74, 133), rgb(0, 74, 133)), linear-gradient(rgb(0, 110, 173), rgb(0, 110, 173));
        }

        :active,
        :focus{
            color: ${blueberryDark};
        }
    }
`;

const PatientMessageCard = ({
    message,
    className,
    heading,
}) => {
    return (
        <ComponentWrapper className={className}>
            <Wrapper>
                {heading && <PatientCardHeading>{heading}</PatientCardHeading>}
                <Message>
                    {message}
                </Message>
            </Wrapper>
        </ComponentWrapper>
    );
};

PatientMessageCard.propTypes = {
    message: PropTypes.node,
    className: PropTypes.string,
};

PatientMessageCard.defaultProps = {
    message: null,
    className: '',
};

export default PatientMessageCard;